import { memo } from "react"

const AdditionalDetails = ({ fundDetails }) => {
    return (
        <> <table className='table table-hover table-bordered table-striped'>
            <tbody>
                <tr>
                    <td className='font-bold'>Transfer From</td>
                    <td className='text-truncate'>{fundDetails?.switchFrom}</td>
                    <td className='font-bold'>Transfer To</td>
                    <td className='text-truncate'>{fundDetails?.switchTo}</td>
                </tr>
                <tr>
                    <td className='font-bold'>Next Transaction</td>
                    <td className='text-truncate'>{fundDetails?.nextTransaction}</td>
                    <td className='font-bold'>Rejection Reason</td>
                    <td className='text-truncate'>{fundDetails?.rejectionReason || '-'}</td>
                </tr>
                <tr>
                    <td className='font-bold'>Last Transaction</td>
                    <td className='text-truncate'>{fundDetails?.lastTransaction}</td>
                    <td className='font-bold'>Initiated from</td>
                    <td className='text-truncate'>{fundDetails?.initiatedFrom}</td>
                </tr>
                <tr>
                    <td className='font-bold'>Remaining Insatllments</td>
                    <td className='text-truncate'>{fundDetails?.installmentReamining || '-'}</td>
                    <td className='font-bold'>Modified from</td>
                    <td className='text-truncate'>{fundDetails?.modifiedFrom || '-'}</td>
                </tr>
                <tr>
                    <td className='font-bold'>Insatllment completed</td>
                    <td className='text-truncate'>{fundDetails?.installmentCompleted || '-'}</td>
                    <td className='font-bold'>Pre Order</td>
                    <td className='text-truncate'>{fundDetails?.cancelOnLogout || '-'}</td>
                </tr>
                <tr>
                    <td className='font-bold'>Failed Insatllments</td>
                    <td className='text-truncate'>{fundDetails?.rejectionReason || '-'}</td>
                    <td className='font-bold'>Cancel on logout</td>
                    <td className='text-truncate'>{fundDetails?.cancelOnLogout || '-'}</td>
                </tr>
                <tr>
                    <td className='font-bold'>Exchange Order No.</td>
                    <td className='text-truncate'>{fundDetails?.exchangeOrderNo || '-'}</td>
                    <td className='font-bold'>Last Updated Time</td>
                    <td className='text-truncate'>{fundDetails?.lastUpdatedTime || '-'}</td>
                </tr>
            </tbody>
        </table></>
    )
}
export default memo(AdditionalDetails)